"use strict";

import dispatcher from "./../../dispatcher";

import mapTooltipStore from "./../../store/mapTooltip";

import zIndex from "./zIndex";
import Tooltip from "./Tooltip";

const MAX_LIFE_TIME = 10000;

export default class TooltipController{
	
	constructor(map){
		this.map = map;
		this.setListeners();
		this.tooltip = null;
	}
	
	setListeners(){
		mapTooltipStore.on("change", tooltipDescriptor => this.handleTooltipStoreChange(tooltipDescriptor));
	}

	handleTooltipStoreChange(tooltipDescriptor){
		if(this.tooltip){
			this.tooltip.close();
			this.tooltip = null;
		}
		if(tooltipDescriptor){
			this.tooltip = new Tooltip({
				map: this.map,
				position: tooltipDescriptor.position,
				icon: tooltipDescriptor.icon,
				label: tooltipDescriptor.label,
				zIndex: zIndex.TOOLTIP
			});
			setTimeout(_ => dispatcher.dispatch("removeTooltip", tooltipDescriptor.id), MAX_LIFE_TIME);
		}
	}
}


// WEBPACK FOOTER //
// ./src/view/Map/TooltipController.js